import type { LocationQueryValue } from 'vue-router'

/** The contact ids a dialer link names in `?selected=`: comma-separated or repeated, first-seen order. */
export function linkedContactIds(raw: LocationQueryValue | LocationQueryValue[] | undefined): string[] {
  const values = Array.isArray(raw) ? raw : [raw]
  const ids = values.flatMap((v) => String(v ?? '').split(',')).map((id) => id.trim()).filter(Boolean)
  return [...new Set(ids)]
}
